<template>
    <div>
        <div class="crumbs" hidden="true" style="margin-left:10px;">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> 分销管理
                </el-breadcrumb-item>
                <el-breadcrumb-item>等级配置</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-card shadow="hover"  class="searchCard" >
            <div class='circleNumDiv'>
                <div class='circleNumDiv'>
                    <p class='circleNumP'>
                        <span class='circle1'>{{workData.waitNum1}}</span>
                    </p>
                    <p class='circleNumP'>
                        <span class='circle1'>{{workData.checkNum1}}</span>
                    </p>
                </div>
            </div>
            <span class="label-span">
                <label class="label">投诉时间</label>
                <el-date-picker v-model="query.startTime" value-format='yyyy-MM-dd' placeholder="开始日期" style="width:130px;"> </el-date-picker>
                <el-date-picker v-model="query.endTime" value-format='yyyy-MM-dd' placeholder="结束日期" style="width:130px;" class="mr10"> </el-date-picker>
            </span>
            <span class="label-span">
                    <label class="label">涉及业务</label>
                    <el-select v-model="query.goodsCode"  placeholder="涉及业务" clearable class="handle-input mr10">
                        <el-option v-for="item in select.option"  :key="item.id" :label="item.optVal" :value="item.optKey" />
                    </el-select>
                </span>
            <span class="label-span">
                    <label class="label">投诉类型</label>
                    <el-select v-model="query.tsId"  placeholder="投诉类型" clearable class="handle-input mr10">
                        <el-option key="item.id" label="全部" value="" />
                        <el-option v-for="item in select2.option"  :key="item.id" :label="item.optVal" :value="item.optKey" />
                    </el-select>
                </span>
            <span class="label-span">
                    <label class="label">工单等级</label>
                    <el-select v-model="query.level"  placeholder="投诉类型" clearable class="handle-input mr10">
                        <el-option key="item.id" label="全部" value="" />
                        <el-option key="item.id" label="常规" value="1" />
                        <el-option key="item.id" label="紧急" value="2" />
                    </el-select>
                </span>

            <span class="label-span">
                    <label class="label">投诉号码</label>
                <el-input v-model.trim="query.phone" placeholder="投诉号码"  class="handle-input mr10"></el-input>
                </span>
            <span class="label-span">
                    <label class="label">投诉地市</label>
                <el-input v-model.trim="query.city" placeholder="投诉地市"  class="handle-input mr10"></el-input>
                </span>
            <el-button type="success" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            <el-button type="error" icon="el-icon-refresh"  @click="refreshSearch">重置</el-button>
        </el-card>
        <el-card  shadow="hover"  class="containCard" >
            <el-table :data="tableData" border size="small" class="table"  ref="multipleTable" header-cell-class-name="table-header"  @selection-change="handleSelectionChange"  >
                <el-table-column prop="id" width="80" align="center" label="ID"></el-table-column>
                <el-table-column prop="loginName" width="90" align="center" label="工单客服">
                    <template slot-scope="scope">
                        <span v-if="scope.row.loginName!=null && scope.row.loginName!=''">{{scope.row.loginName.substring(5,scope.row.loginName.length)}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="woType" min-width="90" align="left" label="投诉类型">
                    <template slot-scope="scope">
                        <span v-for="item in select2.option" v-if='scope.row.tsId==item.optKey'>{{item.optVal}}</span>

                    </template>
                </el-table-column>
                <el-table-column prop="phone" min-width="170" align="left" label="办理号码">
                    <template slot-scope="scope">
                        <el-link type='primary' @click='copyText(scope.row.phone)'>{{scope.row.phone}}</el-link><el-tag style='margin-left:10px' type='info'>{{scope.row.city}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="phone" min-width="90" align="center" label="工单等级">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.level==2?'danger':'primary'">{{scope.row.level==2?'紧急':'常规'}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="phone" min-width="110" align="left" label="联系号码">
                    <template slot-scope="scope">
                        <el-link type='primary' @click='copyText(scope.row.phone2)'>{{scope.row.phone2}}</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="status" min-width="90" align="center" label="工单状态">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.status==1?'info':scope.row.status==-1?'danger':'-'">{{scope.row.status==1?'待处理':scope.row.status==-1?'已拒绝':'-'}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="goodsCode" min-width="180" align="left" label="涉及业务">
                    <template slot-scope="scope">
                        <el-link @click='copyText(scope.row.tsContent)' style='font-size:12px;' v-for="item in select.option" v-if='scope.row.goodsCode==item.optKey'>{{item.optVal}}</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="tsContent" min-width="260" align="left" label="投诉内容">
                    <template slot-scope="scope">
                        <div v-if="scope.row.tsContent!=null && scope.row.tsContent!=''">
                            <el-popover  placement="bottom" title="投诉内容"  width="600" trigger="hover" :content="scope.row.tsContent">
                                <el-link slot="reference" @click='copyText(scope.row.tsContent)' style='font-size:12px;line-height: 20px;webkit-line-clamp: 2;-webkit-box-orient: vertical;display: -webkit-box;overflow:hidden;text-overflow: ellipsis;'>{{scope.row.tsContent}}</el-link>
                            </el-popover>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="tsDay" min-width="120" align="center"  label="投诉时间"> </el-table-column>
                <el-table-column prop="orderTime" min-width="160" align="center"  label="订购时间"> </el-table-column>
                <el-table-column prop="createTime" min-width="160" align="center"  label="工单时间"> </el-table-column>
                <el-table-column label="操作" min-width="110" align="center"  fixed="right">
                    <template slot-scope="scope" >
                        <span class='tableOperBtn' @click="handleEdit(scope.$index, scope.row)" ><i class='el-icon-edit'></i> 工单处理</span><br>

                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </el-card>
        <!-- 新建绑定弹出框 -->
        <el-dialog :close-on-click-modal="false" title="工单录入" :modal-append-to-body='false' :visible.sync="addVisible" width='520px'    >
            <el-form ref="form1" :model="form1" label-width="90px">
                <el-form-item required label="投诉类型" >
                    <el-radio-group v-model.trim="form1.tsId" >
                        <el-radio-button v-for="item in select2.option" :label="item.optKey">{{ item.optVal }}</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item required label="投诉号码" class='wid50'>
                    <el-input oninput="value=value.replace(/[^\d]/g,'')" @change='overlength' v-model.trim="form1.phone" placeholder=""></el-input>
                </el-form-item>
                <el-form-item required label="投诉时间" class='wid50'>
                    <el-date-picker v-model="form1.tsDay" value-format='yyyy-MM-dd' placeholder="投诉时间" style="width:100%;"> </el-date-picker>
                </el-form-item>
                <el-form-item required label="涉及业务">
                    <el-select v-model="form1.goodsCode"  placeholder="资源状态" clearable class="wid100">
                        <el-option v-for="item in select.option"  :key="item.id" :label="item.optVal" :value="item.optKey" />
                    </el-select>
                </el-form-item>
                <el-form-item required label="工单内容">
                    <el-input type="textarea" placeholder="请填写工单内容" :rows="5" v-model.trim="form1.tsContent" ></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveForm">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 编辑弹出框 -->
        <el-dialog :close-on-click-modal="false" title="工单处理" :modal-append-to-body='false' :visible.sync="editVisible" top='30px'  width='620px'  >
            <h3><i class='el-icon-s-check theme'></i> 处理流程</h3><br>
            <div class='handleDiv' >
                <el-timeline style='margin-left:10px;'>
                    <el-timeline-item
                        v-for="(item, index) in replyList"
                        :key="index" >
                        <el-tag>{{item.status==1?'工单创建':item.status==2?'工单处理':item.status==-1?'审批拒接':item.status==9?'工单完结':'-'}}</el-tag>
                        <span v-if='item.status==2'><el-tag type='danger' class='ml10'>{{item.isCash==0?'仅退订':item.isCash==1?'已退费':'-'}}<b v-if='item.isCash==1' > - ￥{{item.cash}}</b></el-tag></span>
                        <span class='ml10' style='color:#777'>{{item.createTime}}</span>
                        <br>
                        <div class='ml10 mt5' v-if="item.content!=null && item.content!=''">
                            <el-link v-if='item.status==1' style='font-size:12px;line-height: 20px;'>工单内容：{{item.content}}</el-link>
                            <div v-if='item.status==2'  style='font-size:12px;line-height: 20px;'>
                                处理方案：{{item.content}}<br>
                                <div v-if=' item.imgs!=null '> 订购凭证：
                                    <img  v-for='url in item.imgs.split(",")' @click='seeImg(url)' :src='url' style='vertical-align:bottom;margin-right:10px;width:50px'   />
                                </div>
                                <div style='margin-top:5px;' v-if=' item.fileList!=null '>处理凭证：
                                    <span v-for='item2 in  item.fileList'>
                                           <img v-if="/\.(jpg|png|gif|jpeg)$/i.test(item2.fileName)"  @click='seeImg(item2.filePath)' :src='item2.filePath' style='vertical-align:bottom;margin-right:10px;width:50px;'   />
                                           <span v-else class='cursor mr10' @click="seeImg(item2.filePath)">{{item2.fileName}}  &nbsp;&nbsp;<i class='el-icon-lx-down theme'  ></i></span>
                                        </span>
                                </div>
                            </div>
                            <el-link v-if='item.status==-1 || item.status==9'  style='font-size:12px;line-height: 20px;'>
                                审批说明：{{item.content}}
                            </el-link>

                        </div>

                    </el-timeline-item>
                </el-timeline>
            </div>
            <br><h3><i class='el-icon-s-check red'></i> 审批结果</h3><br>
            <el-form ref="form" :model="form" label-width="80px">
                <el-form-item required label="处理方案" >
                    <el-input type="textarea" placeholder="请填写处理方案" :rows="2" v-model.trim="form.content" ></el-input>
                </el-form-item>
                <el-form-item required label="是否退费" class='wid50'>
                    <el-radio-group v-model.trim="form.isCash" >
                        <el-radio-button  label="0">仅退订</el-radio-button>
                        <el-radio-button  label="1">已退费</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item v-if='form.isCash==1' required label="退费金额" class='wid50'>
                    <el-input oninput="value=value.replace(/[^0-9.]/g,'')"  v-model.trim="form.cash" placeholder=""></el-input>
                </el-form-item>
                <el-form-item label="订购凭证">
                     <span class='imgChooseList2' v-for="(item,index) in img" :key="index">
                            <img class='imgChooseList-img2' :src="img[index]" >
                            <p class='imgChooseList-i2'>
                                <el-tooltip class="item" effect="light" content="查看" placement="bottom-end">
                                    <i class='el-icon-lx-attention' @click="seeImg(img[index])" ></i>
                                </el-tooltip>
                                <el-tooltip class="item" effect="light" content="删除" placement="bottom-start">
                                    <i class='el-icon-delete' @click="delImg(index,'1')"></i>
                                </el-tooltip>
                            </p>
                        </span>
                    <el-button size="mini" circle icon="el-icon-lx-add" @click="addImg" style="margin-left:0px; "></el-button>
                </el-form-item>
                <el-form-item label="处理凭证">
                     <div class='fileChooseList' v-for="(item,index) in file" :key="index">
                            <p class='fileChooseList-text'>{{item.fileName}}</p>
                            <p class='fileChooseList-i'>
                                <el-tooltip class="item" effect="light" content="下载" placement="bottom-end">
                                    <i class='el-icon-lx-down' @click="seeFile(item)" ></i>
                                </el-tooltip>
                                <el-tooltip class="item" effect="light" content="删除" placement="bottom-start">
                                    <i class='el-icon-close' @click="delFile(index,'1')"></i>
                                </el-tooltip>
                            </p>
                        </div>
                    <el-button size="mini" circle icon="el-icon-lx-add" @click="addFile" style="margin-left:0px; "></el-button>
                </el-form-item>
            </el-form>
            <span slot="footer"  class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveHandle">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="选择图片" :modal-append-to-body='false' :visible.sync="showVisible" top="50px" width="1020px">
            <div style="width:100%;height:600px;overflow-y:scroll;margin-top:-30px;">
                <v-content3 ></v-content3>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="选择文件" :modal-append-to-body='false' :visible.sync="showVisible2" top="50px" width="1020px">
            <div style="width:100%;height:600px;overflow-y:scroll;margin-top:-30px;">
                <v-content4 ></v-content4>
            </div>
        </el-dialog>
        <el-dialog :modal-append-to-body='false' title=""  :visible.sync="dialogVisible" width="380px" top="50px">
            <img width="100%" :src="dialogImageUrl" alt="" style="width:340px;margin-top:15px;">
        </el-dialog>

    </div>
</template>

<script>
import { fetchDataAll as fetchData, saveForm, handDelete, updateHandle, getReplayList, getStateDetail,getWorkOrderShow } from './woHandle';
import {fetchSelect3 as fetchSelect } from '../../api/comGoods';
import {fetchSelect as fetchSelect2} from '../../api/tsType';
import bus from '../../components/common/bus';
import vContent3 from '../../view/system/sysConfig/ComImg.vue';
import vContent4 from '../../view/system/sysConfig/ComFile.vue';
export default {
    name: 'memGrade',
    data() {
        return {
            workData:{},
            replyList:[],
            replyName:'回复',
            stationLogo:'',
            stationName:'',
            avatar:'',
            username:'',
            select:{option:'',},
            select2:{option:'',},
            query: {
                pageIndex: 1,
                pageSize: 10,
            },
            tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            addVisible:false,
            pageTotal: 0,
            form: {
                id:'',
                content:'',
                cash:'',
                isCash:'',
            },
            form1: {
                woType:1,
            },
            idx: -1,
            id: -1,
            dialogImageUrl:'',
            dialogVisible:false,
            showVisible:false,
            showVisible2:false,
            img:[],
            file:[],
            form2: {  },
            editVisible2:false,
        };
    },
    components: {
        vContent3,
        vContent4,
    },
    created() {
        bus.$on('image-choose',  url  => {
            this.img.push(url)  //通过添加array的值，增加input的个数
            this.showVisible = false;
        });
        bus.$on('file-choose',  file  => {
            this.file.push(file)  //通过添加array的值，增加input的个数
            this.showVisible2 = false;
        });
    },
    //页面加载方法
    mounted() {
        this.getSelect();
        this.getSelect2();
        this.getData();
        this.getWorkOrderShow();
    },
    methods: {
        getWorkOrderShow(){
            getWorkOrderShow({ }).then(res => {
                if(res.code=='200'){
                    this.workData = res.data;
                }
            });
        },

        addImg(){
            this.showVisible=true;
        },
        seeImg(url) {
            if(/\.(jpg|png|gif|jpeg)$/i.test(url)){
                this.dialogImageUrl = url;
                this.dialogVisible = true;
            }else{
                window.open(url);
            }
        },
        delImg(index,i){
            this.img.splice(index,1);   //先删除form中value对应索引的值
        },
        addFile(){
            this.showVisible2=true;
        },
        seeFile(file) {
            window.open(file.filePath);
        },
        delFile(index,i){
            this.file.splice(index,1);   //先删除form中value对应索引的值
        },
        copyText(text){
            var copy = document.createElement("input");
            copy.setAttribute("value", text);
            document.body.appendChild(copy);
            copy.select();
            document.execCommand("copy");
            document.body.removeChild(copy);
            //提示已复制
            this.$message.success("内容已复制");
        },
        //获取下拉框数据
        getSelect(){
            this.select = {};
            this.select.channelCode = '46';
            fetchSelect(this.select).then(res => {
                if(res.code=='200'){
                    this.$set(this.select, 'option', res.data);
                }
            });
        },
        getSelect2(){
            this.select2 = {};
            fetchSelect2(this.select2).then(res => {
                if(res.code=='200'){
                    this.$set(this.select2, 'option', res.data);
                }
            });
        },

        overlength(){
            if(this.form1.phone.length>11){
                this.$message.error("投诉号码不超过11位");
            }
            if(this.form1.phone.length<11){
                this.$message.error("投诉号码不少于11位");
            }
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        //刷新
        refresh(){
            history.go(0);
        },
        //重置
        //重置按钮
        refreshSearch(){
            this.$set(this.query, 'startTime');
            this.$set(this.query, 'endTime');
            this.$set(this.query, 'goodsCode');
            this.$set(this.query, 'tsId');
            this.$set(this.query, 'phone');
            this.$set(this.query, 'city');
            this.$set(this.query, 'level');
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
            //清空下拉框
        },
        //查询
        getData(){
            this.query.status='1,-1';
            this.query.sortId = '1';
            fetchData(this.query).then(res => {
                if(res.code=='200'){
                    this.getWorkOrderShow();
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.pageTotal || 0;
                }else{
                    this.tableData = [];
                    this.pageTotal = 0;
                }
            });
        },
        // 关闭订单
        handDelete(index, row) {
            this.$confirm("确定要撤销此工单吗？", '提示', {
                type: 'warning'
            }).then(() => {
                handDelete(row).then(res => {
                    if(res.code=='200'){
                        this.$message.success('撤销成功');
                        this.getData();
                        Bus.$emit("getData");
                    }else if(res.code=='201'){
                        this.$message.error("撤销异常："+res.message);
                    }
                });
            }).catch(() => {});

        },
        // 多选操作

        // 新增绑定
        addBind() {
            this.addVisible = true;
        },
        //保存新增
        saveForm() {
            if( !this.form1.tsId){
                this.$message.error("请选择投诉类型");
                return;
            }
            if( !this.form1.phone ){
                this.$message.error("请选择投诉号码");
                return;
            }if( this.form1.phone.length!=11 ){
                this.$message.error("投诉号码不正确，必须等于11位");
                return;
            }
            if( !this.form1.tsDay){
                this.$message.error("请选择投诉时间");
                return;
            }
            if( !this.form1.goodsCode){
                this.$message.error("请选择投诉业务");
                return;
            }
            if( !this.form1.tsContent){
                this.$message.error("请填写工单内容");
                return;
            }
            this.addVisible = false;
            saveForm(this.form1).then(res => {
                if(res.code=='200'){
                    this.$message.success(res.message);
                    this.getData();
                    Bus.$emit("getData");
                }else{
                    this.$message.error(res.message);
                }
            });
        },
        // 编辑操作
        handleEdit(index, row) {
            let data = {};
            data.sid = row.id;
            getStateDetail(data).then(res => {
                if(res.code=='200'){
                    this.form2 = row;
                    this.replyList = res.data;
                    let data = row;
                    this.form.id = data.id;
                    this.form.content = data.handleContent;
                    this.form.cash = data.handleCash;
                    this.form.isCash = data.isCash;
                    if(data.handleImgs!=null && data.handleImgs!=''){
                        this.img = data.handleImgs.split(",");
                    }else{
                        this.img = [];
                    }
                    if(data.handleFiles!=null && data.handleFiles!=''){
                        this.file = data.fileList;
                    }else{
                        this.file = [];
                    }
                    this.editVisible = true;
                }else{
                    this.$message.error(res.message);
                }
            });
        },
        // 保存编辑
        saveHandle() {
            if( !this.form.isCash){
                this.$message.error("请选择是否退费");
                return;
            }
            if( this.form.isCash==1 && !this.form.cash){
                this.$message.error("请填写退费金额！");
                return;
            }
            if( this.img!=null && this.img!='' ){
                this.form.imgs = this.img.join();
            }
            if( this.file!=null && this.file!='' ){
                this.form.files = JSON.stringify(this.file);
            }
            this.form.reply = '2';
            this.form.status='2';
            this.editVisible = false;
            updateHandle(this.form).then(res => {
                if(res.code=='200'){
                    this.getData();
                    this.$message.success("处理成功");
                }else{
                    this.$message.error(res.message);
                }
            });
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>
<style scoped>
.handleDiv{
    width:96%;background:#fff;padding:15px 10px;height:160px;
    border:1px dashed #aaa;border-radius:5px;overflow-y: scroll;
}
.handleDiv::-webkit-scrollbar {
    width: 6px;       /* 竖向宽度 */
    height: 5px;      /* 横向高度（可选） */
}
.handleDiv::-webkit-scrollbar-thumb{
    background: #bbb;
    border-radius: 3px; /* 圆角建议≤1px避免溢出 */
}
</style>

<style>

@media screen and (max-width:999px){
    .el-dialog--center .el-dialog__body {
        text-align: initial;
        padding: 10px;
    }
    .el-dialog,.el-dialog--center{
        width:315px;
    }
    .el-dialog__header {
        padding: 10px 10px 0px;
    }
    .btnCss{
        height:40px;
        margin-left:10px;
    }
    .handle-del {
        float:left;
        margin-top:10px;
        margin-left:10px;
        margin-right:10px;
    }
}
@media screen and (min-width:999px){
    .el-dialog--center .el-dialog__body {
        text-align: initial;
        padding: 25px 25px 30px;
    }
    .el-dialog__header {
        padding: 20px 20px 0px;
    }

    .el-dialog,.el-dialog--center{
        width:560px;
    }
    .btnCss{

        display:inline-block;
    }
    .handle-del {
        float:right;
    }
}



.handle-box {
    width:100%;
    margin-bottom: 20px;
    overflow-x:auto;
}

.handle-select {
    width: 100px;
    display: inline-block;
}

.handle-input {
    width: 180px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
